import { createApiAction } from '@app/packages/api/utils'
import type { V3PostApplicationsPermanentNannyRequest, V3PostApplicationsPermanentSitterRequest } from '@app/packages/api/v3/types/params'

export const postApplicationsPermanentNanny = (body: V3PostApplicationsPermanentNannyRequest) =>
  createApiAction('postApplicationsPermanentNanny', dispatch =>
    dispatch<void>({
      endpoint: '/api/v3/applications/permanent_nanny',
      method: 'POST',
      body: JSON.stringify(body),
    })
  )

export const postApplicationsPermanentSitter = (body: V3PostApplicationsPermanentSitterRequest) =>
  createApiAction('postApplicationsPermanentSitter', dispatch =>
    dispatch<void>({
      endpoint: '/api/v3/applications/permanent_sitter',
      method: 'POST',
      body: JSON.stringify(body),
    })
  )
